import React, { useEffect } from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  kDefaultMapStyle,
  selectMapStyle,
  setMapStyle,
} from 'state/workflowSlice';

import { MapStyle } from 'appConstants';
import { StlPopup } from 'features/common/StlPopup/StlPopup';
import { classNames } from 'features/common/utils';

import map_style_dark from '../icons/map-style-dark.png';
import map_style_light from '../icons/map-style-light.png';
import map_style_satellite from '../icons/map-style-satellite.png';
import { MapControl } from '../utils/mapControls';
import { kSettingsControlId } from '../utils/map_constants';

import styles from '../Map.module.css';

export function MapSettings({
  open,
  handleVisSwitch,
}: {
  open: boolean;
  handleVisSwitch: (val: boolean) => void;
}) {
  const dispatch = useAppDispatch();
  const mapStyle = useAppSelector(selectMapStyle);

  useEffect(() => {
    MapControl.setValue(open, kSettingsControlId);
  }, [open]);

  if (!open) return null;
  return (
    <StlPopup
      isOpen={open}
      onClose={() => handleVisSwitch(false)}
      title="Basemap Style"
      cancel={false}
      apply={false}
      sx={{ minWidth: '15rem' }}
    >
      <RadioGroup
        value={mapStyle || kDefaultMapStyle}
        aria-labelledby="map_style_label"
        onChange={(event, value) => {
          dispatch(setMapStyle(value));
          handleVisSwitch(false);
        }}
        className={styles.map_style_switcher}
      >
        <FormControlLabel
          value={MapStyle.Dark}
          className={classNames(
            styles.map_style_form_control,
            (mapStyle || kDefaultMapStyle) === MapStyle.Dark
              ? styles.map_style_active
              : styles.map_style_inactive,
          )}
          control={<Radio />}
          label={
            <>
              Dark
              <img
                className={styles.map_style_img}
                src={map_style_dark}
                alt=""
              />
            </>
          }
        />
        <FormControlLabel
          value={MapStyle.Sat}
          control={<Radio />}
          className={classNames(
            styles.map_style_form_control,
            (mapStyle || kDefaultMapStyle) === MapStyle.Sat
              ? styles.map_style_active
              : styles.map_style_inactive,
          )}
          label={
            <>
              Satellite
              <img
                className={styles.map_style_img}
                src={map_style_satellite}
                alt=""
              />
            </>
          }
        />
        <FormControlLabel
          value={MapStyle.Light}
          control={<Radio />}
          className={classNames(
            styles.map_style_form_control,
            (mapStyle || kDefaultMapStyle) === MapStyle.Light
              ? styles.map_style_active
              : styles.map_style_inactive,
          )}
          label={
            <>
              Light
              <img
                className={styles.map_style_img}
                src={map_style_light}
                alt=""
              />
            </>
          }
        />
      </RadioGroup>
    </StlPopup>
  );
}
